import dayjs from 'dayjs';

type MonthlyDataPoint = {
  date: string;
  completed: number;
};

export type MonthlyAggregation = 'average' | 'total';

type MonthlyTotals = Record<string, { count: number; total: number }>;

export const groupDataByMonth = (
  data: MonthlyDataPoint[],
  labels: string[],
  aggregation: MonthlyAggregation = 'average',
): number[] => {
  const monthlyTotals: MonthlyTotals = {};

  data.forEach((item) => {
    const monthLabel = dayjs(item.date).format('YYYY-MM');
    const current = monthlyTotals[monthLabel] ?? { count: 0, total: 0 };

    monthlyTotals[monthLabel] = {
      count: current.count + 1,
      total: current.total + item.completed,
    };
  });

  return labels.map((label) => {
    const monthlyTotal = monthlyTotals[label];
    if (!monthlyTotal) return 0;
    if (aggregation === 'total') return monthlyTotal.total;

    return Math.round((monthlyTotal.total / monthlyTotal.count) * 100) / 100;
  });
};
